export default __webpack_public_path__ + "static/media/newt-cloud-logo-knockout.2d91d208.svg";